// extracted by mini-css-extract-plugin
export var productImage = "_o5-1";
export var viewLink = "_o5-2";
export var wishlistItem = "_o5-0";